import { IconButton } from '@mui/material';
import BackIcon from '../../assets/icons/back-icon';
import { FC } from 'react';

import * as S from './styles';
import { BackButtonProps } from './back-button.types';

export const BackButton: FC<BackButtonProps> = (props) => {
  const { onClick } = props;
  return (
    <S.BackButtonStyle>
      <IconButton size="large" onClick={onClick}>
        <BackIcon width={24} height={24} />
      </IconButton>
    </S.BackButtonStyle>
  );
};
